import React from "react"
import classed from "classed-components"
export const LinkBtn = classed.span(`cursor-pointer
		hover:underline `)
